/**
 * Builds a map of subcategories from the categories hierarchy
 * @param {Array} categoriesData - Categories data with nested children
 * @returns {Object} - Map of parent ID to array of children
 */
export const buildSubCategoriesMap = (categoriesData) => {
  if (!Array.isArray(categoriesData)) return {}

  const subCategoriesMap = {}

  const processCategory = (category) => {
    if (category.children && category.children.length) {
      subCategoriesMap[category.id] = category.children

      // Process children recursively
      category.children.forEach(processCategory)
    }
  }

  categoriesData.forEach(processCategory)

  return subCategoriesMap
}
